import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SurgeryLocation, SurgeryLocationsResponse } from '@shared/models';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SurgeryLocationsService {
  #http = inject(HttpClient);
  #apiUrl = environment.apiUrl;
  #defaultPerPage = 1000;
  #authHeaders = new HttpHeaders({
    Authorization: '',
  });

  fetchSurgeryLocations(name?: string): Observable<SurgeryLocation[]> {
    const params = new HttpParams()
      .set('name', name ?? '')
      .set('per_page', this.#defaultPerPage.toString());

    return this.#http
      .get<SurgeryLocationsResponse>(`${this.#apiUrl}/api/surgeryplace/list`, {
        headers: this.#authHeaders,
        params,
      })
      .pipe(map((resp) => resp.data));
  }

  fetchSurgeryLocationsByID(id: number): Observable<SurgeryLocation[]> {
    const params = new HttpParams()
      .set('id', id.toString())
      .set('per_page', this.#defaultPerPage.toString());

    return this.#http
      .get<SurgeryLocationsResponse>(`${this.#apiUrl}/api/surgeryplace/list`, {
        headers: this.#authHeaders,
        params,
      })
      .pipe(map((resp) => resp.data));
  }
}
